import React from 'react'
import Logo from '../../../Logo/Logo'
import NavigationItems from '../NavigationItems/NavigationItems'
import './Toolbar.scss'

const Toolbar = (props) => (
        <header className="Toolbar">
            <div onClick={props.menuClicked} className="DrawerToggle">
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className="logo-wrapper">
                <Logo />
            </div>
            <nav>
                <NavigationItems activeLink="Burger Builder" isAuth={props.isAuth}/>
            </nav>
        </header>
)

export default Toolbar
